import * as request from "superagent";
import {Response, SuperAgentRequest, SuperAgentStatic} from "superagent";
import {LiveOrLineType} from "../../../store/spirs/types";
import { getFixturesSimple } from "../../../spirsApi/api-client";

export type Responses<T> = Promise<ResponseWithBody<200, T> | ResponseWithBody<201, void> | ResponseWithBody<401, void> | ResponseWithBody<403, void> | ResponseWithBody<404, void>>;

export type RequestHeaders = {
    [header: string]: string;
}
export type RequestHeadersHandler = (headers: RequestHeaders) => RequestHeaders;

export type ConfigureAgentHandler = (agent: SuperAgentStatic) => SuperAgentStatic;

export type ConfigureRequestHandler = (agent: SuperAgentRequest) => SuperAgentRequest;

export type CallbackHandler = (err: any, res ?: request.Response) => void;

export type CompetitorElement = {
    //homeAway
    'ha'?: "Home" | "Away";
    //id
    'i': number;
    //name
    'n': string;
};

export type CouponForm = {
    'acceptType'?: "DO_NOT_ACCEPT_CHANGES" | "ACCEPT_PROMOTION" | "ACCEPT_ANY_CHANGES";
    'playerId'?: string;
    'steps'?: Array<CouponStepForm>;
};

export type HostPort = {
    'host'?: string;
    'port'?: string;
};

export type CouponStepForm = {
    'events'?: Array<EventForm>;
    'm'?: number;
    'n'?: number;
    'odds'?: number;
    'rate'?: number;
    'type'?: "ORDINAR" | "EXPRESS" | "SYSTEM";
};

export type EventClockElement = {
    'eventTime'?: string;
    'remainingTime'?: string;
    'remainingTimeInPeriod'?: string;
    'stoppageTime'?: string;
    'stoppageTimeAnnounced'?: string;
    'stopped'?: boolean;
};

export type EventForm = {
    'active'?: boolean;
    'odds'?: number;
    'rate'?: number;
    'selectionId': number;
};

export type EventResultElement = {
    'awayScore'?: number;
    'climber'?: number;
    'climberDecimal'?: number;
    'climberRanking'?: number;
    'homeScore'?: number;
    'matchStatus'?: number;
    'points'?: number;
    'pointsDecimal'?: number;
    'position'?: number;
    'sprint'?: number;
    'sprintDecimal'?: number;
    'sprintRanking'?: number;
    'status'?: string;
    'statusComment'?: string;
    'time'?: string;
    'timeRanking'?: number;
    'wcPoints'?: number;
};

export type FavoritesFilter = {
    'fixtureId'?: number;
    'playerId'?: string;
};

export type FixtureSearch = {
    live: FixtureElement[];
    prematch: FixtureElement[];
    manyData: boolean;
    empty: true;
}

export type FixtureElement = {
    //competitionName
    'cn': string;
    //competitors
    'c': Array<CompetitorElement>;
    //endTime
    'et'?: string;
    //endTimeRating
    'etr'?: string;
    //favorite
    'f'?: boolean;
    //fixtureId
    'fi': number;
    //fixtureWidgetId
    'fw'?: number;
    //fixtureWidgetConfigurationId
    'wci'?: string;
    //groupedMarkets
    'gm': Array<GroupedMarketElements>;
    //matchStatus
    'ms'?: MatchStatusElement;
    //periods
    'p': Array<PeriodElement>;
    //rating
    'r': boolean;
    //roundName
    'rn'?: string;
    //color
    'sc': string;
    //soccerStatistics
    'ss'?: SoccerStatisticsElement;
    //startTime
    'st'?: string;
    //startTimeRating
    'str'?: string;
    //imageUrl
    'siu': string;
    //sportId
    'sid': number;
    //categoryId
    'cid': number;
    //tournamentId
    'tid': number;
    //sportName
    'sn': string;
    //categoryName
    'ctn': string;
    //tournamentName
    'tn': string;
    //categoryImageUrl
    'ciu'?: string;
    //status
    's': "NOT_STARTED" | "LIVE" | "CANCELLED" | "SUSPENDED" | "ENDED" | "FINISHED" | "ABANDONED" | "DELAYED" | "UNKNOWN" | "POSTPONED" | "INTERRUPTED";
    //available
    'a': boolean;
    //chessLive
    'cl': boolean;
    //sportBetUrl
    'su': string | null;
    //producer
    'pr': 'LIVE' | 'PREMATCH'
    //fixtureSuspended
    'fsd': boolean;
};

export type FixtureStatus = FixtureElement['s'];

export type GroupedMarketElements = {
    //name
    'n': MarketElement["n"];
    //group
    'g': MarketElement["g"];
    //periodGroup
    'pg': MarketElement["pg"];
    //markets
    'm': Array<MarketElement>;
};

export type MarketElement = {
    //columnCount
    'c': number;
    //group
    'g': "NONE" | "AWAY_WILL_SCORE" | "HOME_WILL_SCORE" | "BOTH_WILL_SCORE" | "BOTH_WILL_SCORE_HALF1" | "BOTH_WILL_SCORE_HALF2" | "BOTH_WILL_SCORE_PERIOD1" | "BOTH_WILL_SCORE_PERIOD2" | "BOTH_WILL_SCORE_PERIOD3" | "DOUBLE_CHANCE" | "DOUBLE_CHANCE_HALF1" | "DOUBLE_CHANCE_HALF2" | "DOUBLE_CHANCE_HF1" | "DOUBLE_CHANCE_HF2" | "DOUBLE_CHANCE_QTR1" | "DOUBLE_CHANCE_QTR2" | "DOUBLE_CHANCE_QTR3" | "DOUBLE_CHANCE_QTR4" | "DOUBLE_CHANCE_PERIOD1" | "DOUBLE_CHANCE_PERIOD2" | "DOUBLE_CHANCE_PERIOD3" | "IND_TOTAL_HOME" | "IND_TOTAL_AWAY" | "IND_TOTAL_HOME_HALF1" | "IND_TOTAL_AWAY_HALF1" | "IND_TOTAL_HOME_HALF2" | "IND_TOTAL_AWAY_HALF2" | "IND_TOTAL_CARDS_HOME" | "IND_TOTAL_CARDS_AWAY" | "IND_TOTAL_CARDS_HOME_HALF1" | "IND_TOTAL_CARDS_AWAY_HALF1" | "IND_TOTAL_CORNERS_HOME" | "IND_TOTAL_CORNERS_AWAY" | "IND_TOTAL_CORNERS_HOME_HALF1" | "IND_TOTAL_CORNERS_AWAY_HALF1" | "IND_TOTAL_HOME_FULL_OT_PS" | "IND_TOTAL_AWAY_FULL_OT_PS" | "IND_TOTAL_HOME_PERIOD1" | "IND_TOTAL_HOME_PERIOD2" | "IND_TOTAL_HOME_PERIOD3" | "IND_TOTAL_AWAY_PERIOD1" | "IND_TOTAL_AWAY_PERIOD2" | "IND_TOTAL_AWAY_PERIOD3" | "IND_TOTAL_AWAY_MAP1" | "IND_TOTAL_AWAY_MAP2" |  "IND_TOTAL_AWAY_MAP3" | "IND_TOTAL_AWAY_MAP4" | "IND_TOTAL_AWAY_MAP5" | "IND_TOTAL_AWAY_MAP6" | "IND_TOTAL_AWAY_MAP7" | "IND_TOTAL_HOME_MAP1" | "IND_TOTAL_HOME_MAP2" | "IND_TOTAL_HOME_MAP3" | "IND_TOTAL_HOME_MAP4" | "IND_TOTAL_HOME_MAP5" | "IND_TOTAL_HOME_MAP6" | "IND_TOTAL_HOME_MAP7" | "IND_TOTAL_HOME_HF1" | "IND_TOTAL_AWAY_HF1" | "IND_TOTAL_HOME_HF2" | "IND_TOTAL_AWAY_HF2" | "IND_TOTAL_HOME_FULL_OT" | "IND_TOTAL_AWAY_FULL_OT" | "IND_TOTAL_HOME_QTR1" | "IND_TOTAL_AWAY_QTR1" | "IND_TOTAL_HOME_QTR2" | "IND_TOTAL_AWAY_QTR2" | "IND_TOTAL_HOME_QTR3" | "IND_TOTAL_AWAY_QTR3" | "IND_TOTAL_HOME_QTR4" | "IND_TOTAL_AWAY_QTR4" | "IND_TOTAL_HOME_FULL" | "IND_TOTAL_AWAY_FULL" | "IND_TOTAL_HOME_FULL_EI" | "IND_TOTAL_AWAY_FULL_EI" | "IND_TOTAL_HOME_INNING1" | "IND_TOTAL_HOME_INNING2" | "IND_TOTAL_HOME_INNING3" | "IND_TOTAL_HOME_INNING4" | "IND_TOTAL_HOME_INNING5" | "IND_TOTAL_HOME_INNING6" | "IND_TOTAL_HOME_INNING7" | "IND_TOTAL_HOME_INNING8" | "IND_TOTAL_HOME_INNING9" | "IND_TOTAL_AWAY_INNING1" | "IND_TOTAL_AWAY_INNING2" | "IND_TOTAL_AWAY_INNING3" | "IND_TOTAL_AWAY_INNING4" | "IND_TOTAL_AWAY_INNING5" | "IND_TOTAL_AWAY_INNING6" | "IND_TOTAL_AWAY_INNING7" | "IND_TOTAL_AWAY_INNING8" | "IND_TOTAL_AWAY_INNING9" | "IND_TOTAL_HOME_CRICKET_INNING1" | "IND_TOTAL_HOME_CRICKET_INNING2" | "IND_TOTAL_AWAY_CRICKET_INNING1" | "IND_TOTAL_AWAY_CRICKET_INNING2" | "IND_TOTAL_HOME_SET1" | "IND_TOTAL_AWAY_SET1" | "IND_TOTAL_HOME_SET2" | "IND_TOTAL_AWAY_SET2" | "IND_TOTAL_HOME_SET3" | "IND_TOTAL_AWAY_SET3" | "WINNER" | "WINNER_HALF1" | "WINNER_HALF2" | "WINNER_CARDS" | "WINNER_CARDS_HALF1" | "WINNER_CARDS_HALF2" | "WINNER_CORNERS" | "WINNER_CORNERS_HALF1" | "WINNER_CORNERS_HALF2" | "WINNER_SET1" | "WINNER_SET2" | "WINNER_SET3" | "WINNER_SET4" | "WINNER_SET5" | "WINNER_SET6" | "WINNER_SET7" | "WINNER_PERIOD1" | "WINNER_PERIOD2" | "WINNER_PERIOD3" | "WINNER_HF1" | "WINNER_HF2" | "WINNER_QTR1" | "WINNER_QTR2" | "WINNER_QTR3" | "WINNER_QTR4" | "WINNER_FULL_OT" | "WINNER_FULL_OT_PS" | "WINNER_FULL_EI" | "WINNER_INNING1" | "WINNER_INNING2" | "WINNER_INNING3" | "WINNER_INNING4" | "WINNER_INNING5" | "WINNER_INNING6" | "WINNER_INNING7" | "WINNER_INNING8" | "WINNER_INNING9" | "WINNER_CRICKET_INNING1" | "WINNER_CRICKET_INNING2" | "WINNER_MAP1" | "WINNER_MAP2" | "WINNER_MAP3" | "WINNER_MAP4" | "WINNER_MAP5" | "WINNER_MAP6" | "WINNER_MAP7" | "TOTAL" | "TOTAL_HALF1" | "TOTAL_HALF2" | "TOTAL_CARDS" | "TOTAL_CARDS_HALF1" | "TOTAL_CARDS_HALF2" | "TOTAL_CORNERS" | "TOTAL_CORNERS_HALF1" | "TOTAL_CORNERS_HALF2" | "TOTAL_SET1" | "TOTAL_SET2" | "TOTAL_SET3" | "TOTAL_SET4" | "TOTAL_SET5" | "TOTAL_SET6" | "TOTAL_SET7" | "TOTAL_PERIOD1" | "TOTAL_PERIOD2" | "TOTAL_PERIOD3" | "TOTAL_HF1" | "TOTAL_HF2" | "TOTAL_FULL_OT" | "TOTAL_FULL_OT_PS" | "TOTAL_QTR1" | "TOTAL_QTR2" | "TOTAL_QTR3" | "TOTAL_QTR4" | "TOTAL_FULL_EI" | "TOTAL_INNING1" | "TOTAL_INNING2" | "TOTAL_INNING3" | "TOTAL_INNING4" | "TOTAL_INNING5" | "TOTAL_INNING6" | "TOTAL_INNING7" | "TOTAL_INNING8" | "TOTAL_INNING9" | "TOTAL_CRICKET_INNING1" | "TOTAL_CRICKET_INNING2" | "TOTAL_FRAMES" | "TOTAL_MAP1" | "TOTAL_MAP2" | "TOTAL_MAP3" | "TOTAL_MAP4" | "TOTAL_MAP5" | "TOTAL_MAP6" | "TOTAL_MAP7" | "HANDICAP" | "HANDICAP_HALF1" | "HANDICAP_HALF2" | "HANDICAP_CORNERS" | "HANDICAP_CORNERS_HALF1" | "HANDICAP_CORNERS_HALF2" | "HANDICAP_SET1" | "HANDICAP_SET2" | "HANDICAP_SET3" | "HANDICAP_SET4" | "HANDICAP_SET5" | "HANDICAP_SET6" | "HANDICAP_SET7" | "HANDICAP_PERIOD1" | "HANDICAP_PERIOD2" | "HANDICAP_PERIOD3" | "HANDICAP_MAP1" | "HANDICAP_MAP2" | "HANDICAP_MAP3" | "HANDICAP_MAP4" | "HANDICAP_MAP5" | "HANDICAP_MAP6" | "HANDICAP_MAP7" | "HANDICAP_HF1" | "HANDICAP_HF2" | "HANDICAP_FULL_OT" | "HANDICAP_FULL_OT_PS" | "HANDICAP_QTR1" | "HANDICAP_QTR2" | "HANDICAP_QTR3" | "HANDICAP_QTR4" | "HANDICAP_FULL_EI" | "HANDICAP_INNING1" | "HANDICAP_INNING2" | "HANDICAP_INNING3" | "HANDICAP_INNING4" | "HANDICAP_INNING5" | "HANDICAP_INNING6" | "HANDICAP_INNING7" | "HANDICAP_INNING8" | "HANDICAP_INNING9" | "HANDICAP_FRAMES" | "EXACT_QUANTITY" | "CORRECT_SCORE";
    //id
    'i': number;
    //maxRate
    'ma': number;
    //minRate
    'mi': number;
    //name
    'n': string;
    //periodGroup
    'pg': "NONE" | "HALF1" | "HALF2" | "FULL_MATCH" | "FULL_MATCH_OT" | "FULL_MATCH_OT_PS" | "FULL_MATCH_EI" | "ADDITIONAL" | "CARDS" | "CARDS_HALF1" | "CARDS_HALF2" | "CORNERS" | "CORNERS_HALF1" | "CORNERS_HALF2" | "SET1" | "SET2" | "SET3" | "SET4" | "SET5" | "SET6" | "SET7" | "SET8" | "SET9" | "SET10" | "SET11" | "SET12" | "SET13" | "PERIOD1" | "PERIOD2" | "PERIOD3" | "HF1" | "HF2" | "QTR1" | "QTR2" | "QTR3" | "QTR4" | "INNING1" | "INNING2" | "INNING3" | "INNING4" | "INNING5" | "INNING6" | "INNING7" | "INNING8" | "INNING9" | "CRICKET_INNINGS1" | "CRICKET_INNINGS2" | "FRAME1" | "FRAMES" | "MAP1" | "MAP2" | "MAP3" | "MAP4" | "MAP5" | "MAP6" | "MAP7" | "STATS";
    //selections
    'sel': Array<SelectionElement>;
    //status
    's': "ACTIVE" | "SUSPENDED" | "DEACTIVATED" | "SETTLED" | "CANCELLED" | "HANDED_OVER";
    //updateDuration
    'u': string;
    //column displaying descriptor
    'cm': ColumnMapper;

};

export type ColumnMapper = {
    //display first column
    'c1': boolean;
    //display second column
    'c2': boolean;
    // display second column
    'c3': boolean;
}

export type MarketLimit = {
    'minPoints': number;
    'maxPoints': number;
    'marketId': string;
}

export type MatchStatusElement = {
    'awayBatter'?: number;
    'awayDismissals'?: number;
    'awayGamescore'?: number;
    'awayLegscore'?: number;
    'awayPenaltyRuns'?: number;
    'awayPenaltyScore'?: number;
    'awayRemainingBowls'?: number;
    'awayScore'?: number;
    'awaySuspend'?: number;
    'balls'?: number;
    'bases'?: string;
    'currentCtTeam'?: number;
    'currentEnd'?: number;
    'currentServer'?: number;
    'delivery'?: number;
    'eventClock'?: EventClockElement;
    'eventResults'?: Array<EventResultElement>;
    'expediteMode'?: boolean;
    'fixtureStatus'?: "NOT_STARTED" | "LIVE" | "CANCELLED" | "SUSPENDED" | "ENDED" | "FINISHED" | "ABANDONED" | "DELAYED" | "UNKNOWN" | "POSTPONED" | "INTERRUPTED";
    'homeBatter'?: number;
    'homeDismissals'?: number;
    'homeGamescore'?: number;
    'homeLegscore'?: number;
    'homePenaltyRuns'?: number;
    'homePenaltyScore'?: number;
    'homeRemainingBowls'?: number;
    'homeScore'?: number;
    'homeSuspend'?: number;
    'innings'?: number;
    'matchStatus'?: string;
    'matchStatusId'?: number;
    'outs'?: number;
    'over'?: number;
    'periodScores'?: Array<PeriodScoreElement>;
    'position'?: number;
    'possession'?: number;
    'remainingReds'?: number;
    'strikes'?: number;
    'tiebreak'?: boolean;
    'visit'?: number;
    'yards'?: number;
};

export type PeriodElement = {
    'g': "NONE" | "HALF1" | "HALF2" | "FULL_MATCH" | "FULL_MATCH_OT" | "FULL_MATCH_OT_PS" | "FULL_MATCH_EI" | "ADDITIONAL" | "CARDS" | "CARDS_HALF1" | "CORNERS" | "CORNERS_HALF1" | "SETS" | "SET1" | "SET2" | "SET3" | "SET4" | "SET5" | "SET6" | "SET7" | "SET8" | "SET9" | "SET10" | "SET11" | "SET12" | "SET13" | "PERIODS" | "PERIOD1" | "PERIOD2" | "PERIOD3" | "HF1" | "HF2" | "QTRS" | "QTR1" | "QTR2" | "QTR3" | "QTR4" | "INNINGS" | "STATS";
    'n': string;
};

export type FingerPrintType = {
    adBlock: any
    doNotTrack: any
    screenResolution: any
    pixelRatio: any
    cpuClass: any
    deviceMemory: any
    touchSupport: any
    indexedDb: any
    openDatabase: any
    language: any
    localStorage: any
    platform: any
    plugins: any
    timezone: any
    webgl: any
    canvas: any
    fonts: any
    hardwareConcurrency: any
} & {
    [key: string]: any;
};

export type PeriodScoreElement = {
    'awayScore'?: number;
    'homeScore'?: number;
    'periodDescription'?: string;
    'periodNumber'?: number;
    'periodType'?: "REGULAR_PERIOD" | "OVERTIME" | "PENALTIES" | "OTHER";
};

export type PeriodStatisticsElement = {
    'periodName'?: string;
    'teamStatistics'?: Array<TeamStatisticsElement>;
};

export type PlayerIdShowBalance = {
    'playerId': string,
    'showBalance': boolean,
}

export type PlayerModel = {
    'balance'?: number;
    'birthDate'?: string;
    'birthPlace'?: string;
    'cardNumber'?: string;
    'currency'?: string;
    'currencyScale'?: number;
    'document'?: string;
    'gender'?: string;
    'issuedBy'?: string;
    'issuedDate'?: string;
    'maxRate'?: number;
    'maxSteps'?: number;
    'name'?: string;
    'nickName'?: string;
    'organization'?: string;
    'patronymic'?: string;
    'playerId': string;
    'subdivisionCode'?: string;
    'surname'?: string;
    'timeZone'?: string;
    'web': boolean;
    'showWelcome': boolean;
    'fingerprintURL'?: string;
    'infoMessage'?: string;
    'maxEraiCoeff'?: number;
    'maxEraiResult'?: number;
    'frozen': boolean;
    'frozenUpTo'?: string
    'showBalance'?: boolean;
};

export type NumberValue = {
    'value': number | null;
};

export type RuleForm = {
    'content': string;
};

export type SelectionElement = {
    //id
    'i': number;
    //locked
    'lc': boolean;
    //name
    'n': string;
    //odds
    'o': number;
    //oddsDirection
    'od': "INCREASED" | "DECREASED" | "NOT_CHANGED";
    //value
    'v'?: number;
    //actionLink
    'al'?: string;
    //line
    'l'?: string;
    //baseLine
    'bl'?: string;
    //ph
    'ph': boolean;
};

export type CategoriesArray = {
    'bc': number;
    'bo': number;
    'bcl': boolean;
    'ci': number;
    'cn': string;
    'ciu': string
}

export type SettingsModel = {
    'acceptType'?: "DO_NOT_ACCEPT_CHANGES" | "ACCEPT_PROMOTION" | "ACCEPT_ANY_CHANGES";
    'defaultLine'?: number;
    'defaultLive'?: number;
    'needConfirm'?: boolean;
    'playerId'?: string;
    'theme'?: string;
};

export type SoccerStatisticsElement = {
    'periodStatistics'?: Array<PeriodStatisticsElement>;
    'totalStatistics'?: Array<TeamStatisticsElement>;
};

export type SportTreeElement = {
    //color
    'sc': string;
    //count
    'bc': number;
    //imageUrl
    'siu'?: string;
    //ordinal
    'bo': number;
    //sportId
    'si': number;
    //sportName
    'sn': string;
    'active': boolean;
    //onlyLive
    'ol': boolean;
    //single
    'sg': boolean;
    //fixtureId
    'sfi': number;
    //status
    'sfs': FixtureStatus;
};

export type FavoritesTree = {
    live: FlatTree
    line: FlatTree
    count: number
    settings: TreeSettings;
    //timestamp
    'v': number;
    markets: Tree['m']
    fixtureWithMarkets: Array<number>;
    matchStatuses: Tree['ms'];
    soccerStatistics: Tree['ss'];
    alreadyStarted: Tree['alrds'];
}

export type TreeSettings = {
    //suspended
    's': boolean;
    //favorites
    'f': Array<number>;
    //prematch producer
    'p': boolean;
    //live producer
    'l': boolean;
}

export type Level = {
    //id
    'i': number;
    //level
    'l': 'SPORT' | 'CATEGORY' | 'FIXTURE'
    //sport id
    'si': number;
    //parent id
    'pi': number;
}

export type FlatTree = {
    //levels
    'l': Array<Level>;
    // hash levels
    'h': number;
    //sports
    's': Record<number, Sport>;
    //categories
    'c': Record<number, Category>;
    //tournaments
    't': Record<number, Tournament>;
    //fixtures
    'fixtures': Record<number, FixtureElement>;
    //settings
    'st': TreeSettings;
    //timestamp
    'v': number;
    //grouped markets
    'm': Record<number, Array<GroupedMarketElements>>;
    //fixture with markets
    'f': Array<number>;
    //matchStatus
    'ms': Record<number, MatchStatusElement | null>;
    //soccerStatistics
    'ss': Record<number, SoccerStatisticsElement | null>;
    //alreadyStarted
    'alrds': Array<number>;
}

export type Tree = {
    //sports
    's': Array<Sport>;
    //settings
    'st': TreeSettings;
    //timestamp
    'v': number;
    //grouped markets
    'm': Record<number, Array<GroupedMarketElements>>;
    //fixture with markets
    'f': Array<number>;
    //matchStatus
    'ms': Record<number, MatchStatusElement | null>;
    //soccerStatistics
    'ss': Record<number, SoccerStatisticsElement | null>;
    //alreadyStarted
    'alrds': Array<number>;
}

export type Sport = {
    //color
    'sc': string;
    //count
    'c': number;
    //imageUrl
    'siu'?: string;
    //ordinal
    'bo': number;
    //sportId
    'si': number;
    //sportName
    'sn': string;
    //chessLive
    'cl': boolean;
    //fixtures
    'f': Array<number>
};

export type Category = {
    //categoryId
    'ci': number;
    //categoryImageUrl
    'ciu': string;
    //categoryName
    'cn': string;
    //count
    'bc'?: number;
    //ordinal
    'bo': number;
    //fixtures
    'f': Array<number>;
    //sport id
    'si': number;
};

export type Match = {
     'id': string;
     'name': string
}

export type TournamentWithCategoryId = {
    categoryId: number;
} & Tournament

export type Tournament = {
    //count
    'bc'?: number;
    //ordinal
    'bo': number;
    //tournamentId
    'ti': number;
    //tournamentName
    'tn': string;
    //categoryImageUrl
    'ciu'?: string;
    //categoryName
    'cn': string;
    //fixtures
    'f': Array<number>;
    //chessLive
    'cl': boolean;
    //category id
    'ci': number;
};

export type StepForm = {
    // рассчитан ли шаг
    'calculated': boolean;
    // дата осуществления ставки
    'date'?: string;
    // описание мероприятия
    'fixture'?: FixtureElement;
    // Идентификационный номер ставки
    'id'?: string;
    // Событие мероприятия
    'market'?: string;
    // Коэффициент купона
    'odds'?: number;
    // Размер ставки
    'rate'?: number;
    // Описание варианта исходов события
    'selection'?: string;
    // Текущий исход
    'status'?: "WAITING" | "REFUND" | "CANCELLED" | "IN_PLAY" | "WINNER" | "LOSER";
    // шаги в купоне
    'steps'?: Array<StepForm>;
    // Тип купона
    'type'?: "ORDINAR" | "EXPRESS" | "SYSTEM";
    // Тип ставки
    'typeName'?: string;
    //
    'win'?: number;
    //
    'winning'?: boolean;
};

export type TeamStatisticsElement = {
    'cards'?: number;
    'cornerKicks'?: number;
    'homeAway'?: "Home" | "Away";
    'redCards'?: number;
    'yellowCards'?: number;
    'yellowRedCards'?: number;
};

export type Response_getCategoryListUsingGET_200 = Array<Category>;
export type Response_getSportListUsingGET_200 = Array<SportTreeElement>;
export type Response_getStepsUsingGET_200 = Array<StepForm>;
export type Response_getTournamentListUsingGET_200 = Array<Tournament>;

export type Logger = {
    log: (line: string) => any
};

export interface ResponseWithBody<S extends number, T> extends Response {
    status: S;
    body: T;
}

export type QueryParameters = {
    [param: string]: any
};

export interface CommonRequestOptions {
    $queryParameters?: QueryParameters;
    $domain?: string;
    $path?: string | ((path: string) => string);
    $retries?: number; // number of retries; see: https://github.com/visionmedia/superagent/blob/master/docs/index.md#retrying-requests
    $timeout?: number; // request timeout in milliseconds; see: https://github.com/visionmedia/superagent/blob/master/docs/index.md#timeouts
    $deadline?: number; // request deadline in milliseconds; see: https://github.com/visionmedia/superagent/blob/master/docs/index.md#timeouts
}

export type MenuItemType = {
    id: string;
    type: 'route' | 'href'
    label: string;
    route: string;
    icon: string;
    color: string;
    children: MenuItemType[];
    counter: boolean;
    translate: boolean;
    withIcon: boolean;
}

export type JsonValue<T> = {
    value: T;
}

export type PageType = {
    id: string
    home: boolean;
    title?: string;
    rows: RowType[];
    translate: boolean;
    slides: boolean;
}

export type RowType = {
    type: 'cards' | 'paragraph' | 'html' | 'action_boxes' | 'columns' | 'TREE_DIRECTORY',
    value?: string;
    cards?: CardType[];
    mode?: LiveOrLineType;
    showFull: boolean;
    fetchDataInInterval: boolean;
    interval?: number;
}

export type CardType = {
    id: string;
    title?: string;
    route: string;
    type: 'row_template' | 'history' | 'gauge' | 'html' | 'rows' | 'status' | 'charts' | 'chess' | 'columns' | 'label' | 'SWITCHER_CHILD_BLOCKS';
    value: string;
    headers?: string[];
    history?: string[][];
    charts?: ChartsType[];
    gauge?: {
        type?: string,
        subArgs: Array<{limit?: number, color: string}>,
        ticks: number[],
        maxValue: number;
        minValue?: number;
        unit?: string;
    };
    rows?: RowType[];
    cards?: CardType[];
    status: boolean;
    height?: number;
    width?: number;
    lineNames?: {key: string, value: string}[];
    translate: boolean;
    entityId?: string[];
}

export type ChartsType = {
    x: string;
    [key:string]: string | number,
}

export type ThemeInfoType = {
    type: ThemeType;
    switchTheme: boolean;
    force: boolean;
}

export type TitleType = {
    value: string;
    size: string;
}

export type LogoType = {
    src: string;
    height: string;
    width: string;
    mobileHeight: string;
    mobileWidth: string;
}

export type HeaderType = {
    logo: LogoType;
    title: TitleType;
    theme: ThemeInfoType;
    withInfo: boolean;
    menu: MenuItemType[];
    mobileMenu: MenuItemType[];
}

export type LeftPanelType = {
    menuType: 'sports' | 'menu';
    menu: MenuItemType[];
    showSearch: boolean;
    showHome: boolean;
    showRating: boolean;
    showMobileMenu: boolean;
    showLogo: boolean;
}

export type RightPanelType = {
    enable: boolean;
    mobilePanel: boolean;
    types: string[];
}

export enum TREE_LIVE_TYPE {
    LIVE = "live",
    LIVE_RATING = "live-rating",
    LIVE_WIDGET = "live-widget",
}

export type FavoritesResultType = {
    ok: boolean;
    count: number;
}

export type matchRouteParams = {
    sportId?: string;
    categoryId?: string;
    tournamentId?: string;
};

/**
 * Api Documentation
 * @class Spirs
 * @param {(string)} [domainOrOptions] - The project domain.
 */
export class Spirs {

    private domain: string = "";
    private errorHandlers: CallbackHandler[] = [];
    private requestHeadersHandler ?: RequestHeadersHandler;
    private configureAgentHandler ?: ConfigureAgentHandler;
    private configureRequestHandler ?: ConfigureRequestHandler;

    constructor(domain ?: string, private logger ?: Logger) {
        if (domain) {
            this.domain = domain;
        }
    }

    setRequestHeadersHandler(handler: RequestHeadersHandler) {
        this.requestHeadersHandler = handler;
    }

    getPlayerIdFromHeader() {
        if (this.requestHeadersHandler) {
            const headers = this.requestHeadersHandler({});
            return headers['player'];
        }
    }

    setDomain(domain: string) {
        this.domain = domain;
    }

    private request(method: string, url: string, body: any, headers: RequestHeaders, queryParameters: QueryParameters, form: any, reject: CallbackHandler, resolve: CallbackHandler, opts: CommonRequestOptions) {
        if (this.logger) {
            this.logger.log(`Call ${method} ${url}`);
        }

        const agent = this.configureAgentHandler ?
            this.configureAgentHandler(request.default) :
            request.default;

        let req = agent(method, url);
        if (this.configureRequestHandler) {
            req = this.configureRequestHandler(req);
        }

        req = req.query(queryParameters);

        headers['Accept'] = '*/*';
        headers['Content-Type'] = 'application/json';

        if (body) {
            req.send(body);

            if (typeof (body) === 'object' && !(body.constructor.name === 'Buffer')) {
                headers['Content-Type'] = 'application/json';
            }
        }

        if (Object.keys(form).length > 0) {
            req.type('form');
            req.send(form);
        }

        if (this.requestHeadersHandler) {
            headers = this.requestHeadersHandler({
                ...headers
            });
        }

        req.set(headers);

        if (opts.$retries && opts.$retries > 0) {
            req.retry(opts.$retries);
        }

        if (opts.$timeout && opts.$timeout > 0 || opts.$deadline && opts.$deadline > 0) {
            req.timeout({
                deadline: opts.$deadline,
                response: opts.$timeout
            });
        }

        console.log(new Date().toISOString() + " [REQUEST] Start " + url)

        req.end((error, response) => {
            // an error will also be emitted for a 4xx and 5xx status code
            // the error object will then have error.status and error.response fields
            // see superagent error handling: https://github.com/visionmedia/superagent/blob/master/docs/index.md#error-handling
            console.log(new Date().toISOString() + " [REQUEST] End " + url)
            if (error) {
                reject(error);
                this.errorHandlers.forEach(handler => handler(error));
            } else {
                resolve(response);
            }
        });
    }

    private convertParameterCollectionFormat<T>(param: T, collectionFormat: string | undefined): T | string {
        if (Array.isArray(param) && param.length >= 2) {
            switch (collectionFormat) {
                case "csv":
                    return param.join(",");
                case "ssv":
                    return param.join(" ");
                case "tsv":
                    return param.join("\t");
                case "pipes":
                    return param.join("|");
                default:
                    return param;
            }
        }

        return param;
    }

    /**
     * Получение дерева категорий спортивных мероприятий для указанного вида спорта
     * @method
     * @name Spirs#getCategoryListUsingGET
     * @param {string} endDate - Окончание временного отрезка для выборки
     * @param {string} mode - Статус спортивного события
     * @param {string} player - Идентификатор участника
     * @param {integer} sportId - Идентификатор вида спорта
     * @param {string} startDate - Начало временного отрезка для выборки
     */
    getCategoryListUsingGET(parameters: {
        'endDate'?: string,
        'mode': "LINE" | "LIVE" | "FINISHED",
        'player'?: string,
        'sportId': number,
        'startDate'?: string,
    } & CommonRequestOptions): Responses<Response_getCategoryListUsingGET_200> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/categories';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';

            if (parameters['endDate'] !== undefined) {
                queryParameters['endDate'] = this.convertParameterCollectionFormat(
                    parameters['endDate'],
                    ''
                );
            }

            if (parameters['mode'] !== undefined) {
                queryParameters['mode'] = this.convertParameterCollectionFormat(
                    parameters['mode'],
                    ''
                );
            }

            if (parameters['mode'] === undefined) {
                reject(new Error('Missing required  parameter: mode'));
                return;
            }

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters['sportId'] !== undefined) {
                queryParameters['sportId'] = this.convertParameterCollectionFormat(
                    parameters['sportId'],
                    ''
                );
            }

            if (parameters['sportId'] === undefined) {
                reject(new Error('Missing required  parameter: sportId'));
                return;
            }

            if (parameters['startDate'] !== undefined) {
                queryParameters['startDate'] = this.convertParameterCollectionFormat(
                    parameters['startDate'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }


    /**
     * Добавить мероприятие в избранное
     * @method
     * @name Spirs#addUsingPOST
     */
    addUsingPOST(parameters: { 'filter': FavoritesFilter, 'player'?: string, } & CommonRequestOptions): Responses<FavoritesResultType> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/favorites/add';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';
            headers['Content-Type'] = 'application/json';

            if (parameters['filter'] !== undefined) {
                body = parameters['filter'];
            }

            if (parameters['filter'] === undefined) {
                reject(new Error('Missing required  parameter: filter'));
                return;
            }

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    deleteUsingPOST(parameters: { 'filter': FavoritesFilter, 'player'?: string, } & CommonRequestOptions): Responses<FavoritesResultType> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/favorites/delete';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';
            headers['Content-Type'] = 'application/json';

            if (parameters['filter'] !== undefined) {
                body = parameters['filter'];
            }

            if (parameters['filter'] === undefined) {
                reject(new Error('Missing required  parameter: filter'));
                return;
            }

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * далить самое устаревшее мероприятие из избранного, если их больше 50
     * @method
     * @name Spirs#deleteOldFavouritePOST
     */
    deleteOldFavouritePOST(parameters: { 'filter': FavoritesFilter }  & CommonRequestOptions): Responses<FavoritesResultType> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/favorites/delete-old';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';
            headers['Content-Type'] = 'application/json';

            if (parameters['filter'] !== undefined) {
                body = parameters['filter'];
            }

            if (parameters['filter'] === undefined) {
                reject(new Error('Missing required  parameter: filter'));
                return;
            }

            if (parameters['filter']['playerId'] !== undefined) {
                headers['playerId'] = parameters['filter']['playerId'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * Получение информации по указанному мероприятию
     * @method
     * @name Spirs#getFixtureUsingGET
     */
    getFixtureUsingGET(parameters: { 'id': number, 'player'?: string, } & CommonRequestOptions): Responses<FixtureElement> {

        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/fixture';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';

            if (parameters['id'] !== undefined) {
                queryParameters['id'] = this.convertParameterCollectionFormat(
                    parameters['id'],
                    ''
                );
            }

            if (parameters['id'] === undefined) {
                reject(new Error('Missing required  parameter: id'));
                return;
            }

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * Получение информации по пользователю(баланс и тд)
     * @method
     * @name Spirs#getPlayerInfoUsingGET
     */
    getPlayerInfoUsingGET(parameters: { 'player'?: string, 'sessiontoken': string, } & CommonRequestOptions): Responses<PlayerModel> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/playerInfo';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters['sessiontoken'] !== undefined) {
                queryParameters['sessiontoken'] = this.convertParameterCollectionFormat(
                    parameters['sessiontoken'],
                    ''
                );
            }

            if (parameters['sessiontoken'] === undefined) {
                reject(new Error('Missing required  parameter: sessiontoken'));
                return;
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * rule
     * @method
     * @name Spirs#ruleUsingGET
     */
    ruleUsingGET(parameters: { 'player'?: string, } & CommonRequestOptions): Responses<RuleForm> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/rules';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * getSettings
     * @method
     * @name Spirs#getSettingsUsingGET
     */
    getSettingsUsingGET(parameters: { 'player'?: string, 'playerId': string, } & CommonRequestOptions): Responses<SettingsModel> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/settings';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters['playerId'] !== undefined) {
                queryParameters['playerId'] = this.convertParameterCollectionFormat(
                    parameters['playerId'],
                    ''
                );
            }

            if (parameters['playerId'] === undefined) {
                reject(new Error('Missing required  parameter: playerId'));
                return;
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * saveSettings
     * @method
     * @name Spirs#saveSettingsUsingPOST
     * @param {} model - model
     * @param {string} player - Идентификатор участника
     */
    saveSettingsUsingPOST(parameters: {
        'model': SettingsModel,
        'player'?: string,
    } & CommonRequestOptions): Responses<SettingsModel> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/settings';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';
            headers['Content-Type'] = 'application/json';

            if (parameters['model'] !== undefined) {
                body = parameters['model'];
            }

            if (parameters['model'] === undefined) {
                reject(new Error('Missing required  parameter: model'));
                return;
            }

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * Получение дерева видов спорта спортивных мероприятий
     * @method
     * @name Spirs#getSportListUsingGET
     * @param {string} player - Идентификатор участника
     */
    getSportListUsingGET(parameters: {
        'player'?: string
    } & CommonRequestOptions): Responses<Response_getSportListUsingGET_200> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/sports';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * Информация по совершенным шагам
     * @method
     * @name Spirs#getStepsUsingGET
     * @param {boolean} calculated - Расчитанные или нет (если не указывать - пришлет все)
     * @param {string} endTime - Фильтр по "дате после"
     * @param {string} player - Идентификатор участника
     * @param {string} playerId - Идентификатор пользователя
     * @param {string} startTime - Фильтр по "дате до"
     */
    getStepsUsingGET(parameters: {
        'calculated'?: boolean,
        'endTime'?: string,
        'player'?: string,
        'playerId': string,
        'startTime'?: string,
    } & CommonRequestOptions): Responses<Response_getStepsUsingGET_200> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/steps';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';

            if (parameters['calculated'] !== undefined) {
                queryParameters['calculated'] = this.convertParameterCollectionFormat(
                    parameters['calculated'],
                    ''
                );
            }

            if (parameters['endTime'] !== undefined) {
                queryParameters['endTime'] = this.convertParameterCollectionFormat(
                    parameters['endTime'],
                    ''
                );
            }

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters['playerId'] !== undefined) {
                queryParameters['playerId'] = this.convertParameterCollectionFormat(
                    parameters['playerId'],
                    ''
                );
            }

            if (parameters['playerId'] === undefined) {
                reject(new Error('Missing required  parameter: playerId'));
                return;
            }

            if (parameters['startTime'] !== undefined) {
                queryParameters['startTime'] = this.convertParameterCollectionFormat(
                    parameters['startTime'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getNotCalculatedStepsUsingGET(parameters: { 'playerId': string, } & CommonRequestOptions): Responses<Response_getStepsUsingGET_200> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/steps/not-calculated';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';
            if (parameters['playerId'] !== undefined) {
                queryParameters['playerId'] = this.convertParameterCollectionFormat(
                    parameters['playerId'],
                    ''
                );
            }

            if (parameters['playerId'] === undefined) {
                reject(new Error('Missing required  parameter: playerId'));
                return;
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * Сохранение купона
     * @method
     * @name Spirs#saveCouponUsingPOST
     * @param {} couponForm - couponForm
     * @param {string} player - Идентификатор участника
     */
    saveCouponUsingPOST(parameters: { 'couponForm': CouponForm, 'player'?: string, } & CommonRequestOptions): Responses<PlayerModel> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/steps/save-coupon';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';
            headers['Content-Type'] = 'application/json';

            if (parameters['couponForm'] !== undefined) {
                body = parameters['couponForm'];
            }

            if (parameters['couponForm'] === undefined) {
                reject(new Error('Missing required  parameter: couponForm'));
                return;
            }

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * Получение обновленных коэффициентов и статусов по маркетам, который еще не сохранен клиентом
     * @method
     * @name Spirs#updateCouponUsingPOST
     * @param {} couponForm - couponForm
     * @param {string} player - Идентификатор участника
     */
    updateCouponUsingPOST(parameters: {
        'couponForm': CouponForm,
        'player'?: string,
    } & CommonRequestOptions): Responses<CouponForm> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/steps/update-coupon';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';
            headers['Content-Type'] = 'application/json';

            if (parameters['couponForm'] !== undefined) {
                body = parameters['couponForm'];
            }

            if (parameters['couponForm'] === undefined) {
                reject(new Error('Missing required  parameter: couponForm'));
                return;
            }

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * Получение дерева турниров спортивных мероприятий для указанных вида спорта и категории
     * @method
     * @name Spirs#getTournamentListUsingGET
     * @param {integer} categoryId - Идентификатор категории
     * @param {string} endDate - Окончание временного отрезка для выборки
     * @param {string} mode - Статус спортивного события
     * @param {string} player - Идентификатор участника
     * @param {integer} sportId - Идентификатор вида спорта
     * @param {string} startDate - Начало временного отрезка для выборки
     */
    getTournamentListUsingGET(parameters: {
        'categoryId': number,
        'endDate'?: string,
        'mode': "LINE" | "LIVE" | "FINISHED",
        'player'?: string,
        'sportId': number,
        'startDate'?: string,
    } & CommonRequestOptions): Responses<Response_getTournamentListUsingGET_200> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/tournaments';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';

            if (parameters['categoryId'] !== undefined) {
                queryParameters['categoryId'] = this.convertParameterCollectionFormat(
                    parameters['categoryId'],
                    ''
                );
            }

            if (parameters['categoryId'] === undefined) {
                reject(new Error('Missing required  parameter: categoryId'));
                return;
            }

            if (parameters['endDate'] !== undefined) {
                queryParameters['endDate'] = this.convertParameterCollectionFormat(
                    parameters['endDate'],
                    ''
                );
            }

            if (parameters['mode'] !== undefined) {
                queryParameters['mode'] = this.convertParameterCollectionFormat(
                    parameters['mode'],
                    ''
                );
            }

            if (parameters['mode'] === undefined) {
                reject(new Error('Missing required  parameter: mode'));
                return;
            }

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters['sportId'] !== undefined) {
                queryParameters['sportId'] = this.convertParameterCollectionFormat(
                    parameters['sportId'],
                    ''
                );
            }

            if (parameters['sportId'] === undefined) {
                reject(new Error('Missing required  parameter: sportId'));
                return;
            }

            if (parameters['startDate'] !== undefined) {
                queryParameters['startDate'] = this.convertParameterCollectionFormat(
                    parameters['startDate'],
                    ''
                );
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    /**
     * getBannerHostPort
     * @method
     * @name Spirs#getBannerHostPortUsingGET
     * @param {string} player - Идентификатор участника
     */
    getBannerHostPortUsingGET(parameters: { player?: string, } & CommonRequestOptions): Responses<HostPort> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/getBannerHostPort';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }


    /**
     * chessLiveSportId
     * @method
     * @name Spirs#chessLiveSportIdUsingGET
     * @param {string} player - Идентификатор участника
     */
    chessLiveSportIdUsingGET(parameters: { player: string } & CommonRequestOptions): Responses<NumberValue> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/chessLiveSportId';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';

            if (parameters['player'] !== undefined) {
                headers['player'] = parameters['player'];
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    sendFingerprintPOST(parameters: { 'value': object, } & CommonRequestOptions): Responses<{ value: number }> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/fingerprint';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';
            headers['Content-Type'] = 'application/json';

            if (parameters['value'] !== undefined) {
                body = {value: parameters['value']};
            }

            if (parameters['value'] === undefined) {
                reject(new Error('Missing required  parameter: value'));
                return;
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            form = queryParameters;
            queryParameters = {};

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    toggleBalanceVisibilityPOST(parameters: { 'sessiontoken': string, 'showBalance': boolean} & CommonRequestOptions): Responses<PlayerIdShowBalance> {
        const domain = parameters.$domain ? parameters.$domain : this.domain;
        let path = '/v1/toggleBalanceVisibility';
        if (parameters.$path) {
            path = (typeof (parameters.$path) === 'function') ? parameters.$path(path) : parameters.$path;
        }

        let body: any;
        let queryParameters: QueryParameters = {};
        let headers: RequestHeaders = {};
        let form: any = {};
        return new Promise((resolve, reject) => {
            headers['Accept'] = '*/*';

            if (parameters['showBalance'] !== undefined) {
                queryParameters['showBalance'] = parameters.showBalance;
            }

            if (parameters['sessiontoken'] !== undefined) {
                queryParameters['sessiontoken'] = this.convertParameterCollectionFormat(
                    parameters['sessiontoken'],
                    ''
                );
            }

            if (parameters['sessiontoken'] === undefined) {
                reject(new Error('Missing required  parameter: sessiontoken'));
                return;
            }

            if (parameters.$queryParameters) {
                queryParameters = {
                    ...queryParameters,
                    ...parameters.$queryParameters
                };
            }

            this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
        });
    }

    getFavoritesTree(): Responses<FavoritesTree> {
        const path = '/v1/favorites/tree';
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    getFavoritesCount(): Responses<NumberValue> {
        const path = '/v1/favorites/count';
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    getTreeFilter(parameters: { sportId: number, categoryId: number, tournamentId: number}): Responses<FlatTree> {
        const path = '/v1/fixtures-tree-filter';
        return new Promise((resolve, reject) => {
            const queryParameters: QueryParameters = {...parameters};
            this.request('GET', this.domain + path, {}, {}, queryParameters, {}, reject, resolve, {});
        })
    }

    getFixturesSimple(parameters: { sportId: number, categoryId: number, tournamentId: number}): Responses<Tree> {
      const path = `/v1/fixture-simple-list`;
        return new Promise((resolve, reject) => {
            const queryParameters: QueryParameters = {...parameters};
            this.request('GET', this.domain + path, {}, {}, queryParameters, {}, reject, resolve, {});
        })
    }

    getSearchResult(parameters: {value: string}): Responses<FixtureSearch> {
        const path = '/v1/fixtures/search-tree';
        return new Promise((resolve, reject) => {
            const queryParameters: QueryParameters = parameters;
            this.request('GET', this.domain + path, {}, {}, queryParameters, {}, reject, resolve, {});
        })
    }

    getTreeResult(parameters: {status: LiveOrLineType, startDate: Date, sport: boolean, chesslive: boolean}): Responses<FlatTree> {
        const path = '/v1/fixtures-tree-result';
        return new Promise((resolve, reject) => {
            const queryParameters: QueryParameters = {...parameters, startDate: parameters.startDate.toISOString(), rating: false};
            this.request('GET', this.domain + path, {}, {}, queryParameters, {}, reject, resolve, {});
        })
    }

    getRatingTree(time: string): Responses<FlatTree> {
        const path = `/v1/rating-fixtures-tree?period=${time}`;
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    getPrematchTree(time: string): Responses<FlatTree> {
        const path = `/v1/all-fixtures-tree?period=${time}`;
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    getTreeLive(parameters: {type: TREE_LIVE_TYPE}): Responses<FlatTree> {
        const path = `/v1/fixtures-tree-${parameters.type}`;
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    acceptWelcome(): Responses<void> {
        const path = '/v1/accept';
        return new Promise((resolve, reject) => {
            this.request('POST', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    getMarketLimit(parameters: {marketId: number, fixtureId: number}): Responses<MarketLimit> {
        const path = '/v1/market-limit';
        return new Promise((resolve, reject) => {
            const queryParameters: QueryParameters = {...parameters};
            this.request('GET', this.domain + path, {}, {}, queryParameters, {}, reject, resolve, {});
        })
    }

    getHomePage(): Responses<JsonValue<PageType>> {
        const path = '/v1/home-page';
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    getPage(parameters: {id: string}): Responses<JsonValue<PageType>> {
        const path = '/v1/page/' + parameters.id;
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    getTheme(): Responses<JsonValue<ThemeInfoType>> {
        const path = '/v1/theme';
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    getRequiredAuth(): Responses<JsonValue<boolean>> {
        const path = '/v1/required-auth';
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    getHeader(): Responses<HeaderType> {
        const path = '/v1/header';
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    getLeftPanel(): Responses<LeftPanelType> {
        const path = '/v1/left-panel';
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    getRightPanel(): Responses<RightPanelType> {
        const path = '/v1/right-panel';
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }

    ping(): Responses<void> {
        const path = "/v1/monitoring/ping";
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }


    getAllFixturesTree(time : string): Responses<JsonValue<ThemeInfoType>> {
        const path = `/v1/all_fixtures_tree?period=${time}`;
        return new Promise((resolve, reject) => {
            this.request('GET', this.domain + path, {}, {}, {}, {}, reject, resolve, {});
        })
    }



    getFixturesSimpleList (parameters: { sportId: number, categoryId: number, tournamentId: number}): Responses<getFixturesSimple> {
      const path = `/v1/fixture-simple-list`;
        return new Promise((resolve, reject) => {
            const queryParameters: QueryParameters = {...parameters};
            this.request('GET', this.domain + path, {}, {}, queryParameters, {}, reject, resolve, {});
        })
    }

}

export default Spirs;
//generated market group titles array
export const marketGroups = ["NONE", "AWAY_WILL_SCORE", "HOME_WILL_SCORE", "BOTH_WILL_SCORE", "BOTH_WILL_SCORE_HALF1", "BOTH_WILL_SCORE_HALF2", "BOTH_WILL_SCORE_PERIOD1", "BOTH_WILL_SCORE_PERIOD2", "BOTH_WILL_SCORE_PERIOD3", "DOUBLE_CHANCE", "DOUBLE_CHANCE_HALF1", "DOUBLE_CHANCE_HALF2", "DOUBLE_CHANCE_HF1", "DOUBLE_CHANCE_HF2", "DOUBLE_CHANCE_QTR1", "DOUBLE_CHANCE_QTR2", "DOUBLE_CHANCE_QTR3", "DOUBLE_CHANCE_QTR4", "DOUBLE_CHANCE_PERIOD1", "DOUBLE_CHANCE_PERIOD2", "DOUBLE_CHANCE_PERIOD3", "IND_TOTAL_HOME", "IND_TOTAL_AWAY", "IND_TOTAL_HOME_HALF1", "IND_TOTAL_AWAY_HALF1", "IND_TOTAL_HOME_HALF2", "IND_TOTAL_AWAY_HALF2", "IND_TOTAL_CARDS_HOME", "IND_TOTAL_CARDS_AWAY", "IND_TOTAL_CARDS_HOME_HALF1", "IND_TOTAL_CARDS_AWAY_HALF1", "IND_TOTAL_CORNERS_HOME", "IND_TOTAL_CORNERS_AWAY", "IND_TOTAL_CORNERS_HOME_HALF1", "IND_TOTAL_CORNERS_AWAY_HALF1", "IND_TOTAL_HOME_FULL_OT_PS", "IND_TOTAL_AWAY_FULL_OT_PS", "IND_TOTAL_HOME_PERIOD1", "IND_TOTAL_HOME_PERIOD2", "IND_TOTAL_HOME_PERIOD3", "IND_TOTAL_AWAY_PERIOD1", "IND_TOTAL_AWAY_PERIOD2", "IND_TOTAL_AWAY_MAP1", "IND_TOTAL_AWAY_MAP2", "IND_TOTAL_AWAY_MAP3", "IND_TOTAL_AWAY_MAP4", "IND_TOTAL_AWAY_MAP5",  "IND_TOTAL_AWAY_MAP6",  "IND_TOTAL_AWAY_MAP7","IND_TOTAL_HOME_MAP1", "IND_TOTAL_HOME_MAP2", "IND_TOTAL_HOME_MAP3", "IND_TOTAL_HOME_MAP4", "IND_TOTAL_HOME_MAP5",  "IND_TOTAL_HOME_MAP6", "IND_TOTAL_HOME_MAP7", "IND_TOTAL_AWAY_PERIOD3", "IND_TOTAL_HOME_HF1", "IND_TOTAL_AWAY_HF1", "IND_TOTAL_HOME_HF2", "IND_TOTAL_AWAY_HF2", "IND_TOTAL_HOME_FULL_OT", "IND_TOTAL_AWAY_FULL_OT", "IND_TOTAL_HOME_QTR1", "IND_TOTAL_AWAY_QTR1", "IND_TOTAL_HOME_QTR2", "IND_TOTAL_AWAY_QTR2", "IND_TOTAL_HOME_QTR3", "IND_TOTAL_AWAY_QTR3", "IND_TOTAL_HOME_QTR4", "IND_TOTAL_AWAY_QTR4", "IND_TOTAL_HOME_FULL", "IND_TOTAL_AWAY_FULL", "IND_TOTAL_HOME_FULL_EI", "IND_TOTAL_AWAY_FULL_EI", "IND_TOTAL_HOME_INNING1", "IND_TOTAL_HOME_INNING2", "IND_TOTAL_HOME_INNING3", "IND_TOTAL_HOME_INNING4", "IND_TOTAL_HOME_INNING5", "IND_TOTAL_HOME_INNING6", "IND_TOTAL_HOME_INNING7", "IND_TOTAL_HOME_INNING8", "IND_TOTAL_HOME_INNING9", "IND_TOTAL_AWAY_INNING1", "IND_TOTAL_AWAY_INNING2", "IND_TOTAL_AWAY_INNING3", "IND_TOTAL_AWAY_INNING4", "IND_TOTAL_AWAY_INNING5", "IND_TOTAL_AWAY_INNING6", "IND_TOTAL_AWAY_INNING7", "IND_TOTAL_AWAY_INNING8", "IND_TOTAL_AWAY_INNING9", "IND_TOTAL_HOME_CRICKET_INNING1", "IND_TOTAL_HOME_CRICKET_INNING2", "IND_TOTAL_AWAY_CRICKET_INNINGS", "IND_TOTAL_AWAY_CRICKET_INNING1", "IND_TOTAL_AWAY_CRICKET_INNING2", "IND_TOTAL_HOME_SET1", "IND_TOTAL_AWAY_SET1", "IND_TOTAL_HOME_SET2", "IND_TOTAL_AWAY_SET2", "IND_TOTAL_HOME_SET3", "IND_TOTAL_AWAY_SET3", "WINNER", "WINNER_HALF1", "WINNER_HALF2", "WINNER_CARDS", "WINNER_CARDS_HALF1", "WINNER_CARDS_HALF2", "WINNER_CORNERS", "WINNER_CORNERS_HALF1", "WINNER_CORNERS_HALF2", "WINNER_SET1", "WINNER_SET2", "WINNER_SET3", "WINNER_SET4", "WINNER_SET5", "WINNER_SET6", "WINNER_SET7", "WINNER_PERIOD1", "WINNER_PERIOD2", "WINNER_PERIOD3", "WINNER_HF1", "WINNER_HF2", "WINNER_QTR1", "WINNER_QTR2", "WINNER_QTR3", "WINNER_QTR4", "WINNER_FULL_OT", "WINNER_FULL_OT_PS", "WINNER_FULL_EI", "WINNER_INNING1", "WINNER_INNING2", "WINNER_INNING3", "WINNER_INNING4", "WINNER_INNING5", "WINNER_INNING6", "WINNER_INNING7", "WINNER_INNING8", "WINNER_INNING9", "WINNER_CRICKET_INNING1", "WINNER_CRICKET_INNING2", "WINNER_MAP1", "WINNER_MAP2", "WINNER_MAP3", "WINNER_MAP4", "WINNER_MAP5", "WINNER_MAP6", "WINNER_MAP7", "TOTAL", "TOTAL_HALF1", "TOTAL_HALF2", "TOTAL_CARDS", "TOTAL_CARDS_HALF1", "TOTAL_CARDS_HALF2", "TOTAL_CORNERS", "TOTAL_CORNERS_HALF1", "TOTAL_CORNERS_HALF2", "TOTAL_SET1", "TOTAL_SET2", "TOTAL_SET3", "TOTAL_SET4", "TOTAL_SET5", "TOTAL_SET6", "TOTAL_SET7", "TOTAL_PERIOD1", "TOTAL_PERIOD2", "TOTAL_PERIOD3", "TOTAL_HF1", "TOTAL_HF2", "TOTAL_FULL_OT", "TOTAL_FULL_OT_PS", "TOTAL_QTR1", "TOTAL_QTR2", "TOTAL_QTR3", "TOTAL_QTR4", "TOTAL_FULL_EI", "TOTAL_INNING1", "TOTAL_INNING2", "TOTAL_INNING3", "TOTAL_INNING4", "TOTAL_INNING5", "TOTAL_INNING6", "TOTAL_INNING7", "TOTAL_INNING8", "TOTAL_INNING9", "TOTAL_CRICKET_INNING1", "TOTAL_CRICKET_INNING2", "TOTAL_FRAMES", "TOTAL_MAP1", "TOTAL_MAP2", "TOTAL_MAP3", "TOTAL_MAP4", "TOTAL_MAP5", "TOTAL_MAP6", "TOTAL_MAP7", "HANDICAP", "HANDICAP_HALF1", "HANDICAP_HALF2", "HANDICAP_CORNERS", "HANDICAP_CORNERS_HALF1", "HANDICAP_CORNERS_HALF2", "HANDICAP_SET1", "HANDICAP_SET2", "HANDICAP_SET3", "HANDICAP_SET4", "HANDICAP_SET5", "HANDICAP_SET6", "HANDICAP_SET7", "HANDICAP_PERIOD1", "HANDICAP_PERIOD2", "HANDICAP_PERIOD3", "HANDICAP_MAP1", "HANDICAP_MAP2", "HANDICAP_MAP3", "HANDICAP_MAP4", "HANDICAP_MAP5", "HANDICAP_MAP6", "HANDICAP_MAP7", "HANDICAP_HF1", "HANDICAP_HF2", "HANDICAP_FULL_OT", "HANDICAP_FULL_OT_PS", "HANDICAP_QTRS", "HANDICAP_QTR1", "HANDICAP_QTR2", "HANDICAP_QTR3", "HANDICAP_QTR4", "HANDICAP_FULL_EI", "HANDICAP_INNING1", "HANDICAP_INNING2", "HANDICAP_INNING3", "HANDICAP_INNING4", "HANDICAP_INNING5", "HANDICAP_INNING6", "HANDICAP_INNING7", "HANDICAP_INNING8", "HANDICAP_INNING9", "HANDICAP_FRAMES"];

export type ViewType = 'LOADING' | 'ERROR' | 'ALL' | 'ONLY_RESULTS';

export type ThemeType = "light" | 'dark'
